// @flow
import get from 'lodash/get';
import set from 'lodash/set';
import isEmpty from 'lodash/isEmpty';

export const addTags = (solMetaData: ?Object, extraTags: Object) =>
  !isEmpty(extraTags)
    ? set(solMetaData, 'tags', { ...get(solMetaData, 'tags'), ...extraTags })
    : solMetaData;
